import gql from 'graphql-tag';

import GraphQLClient, { GraphQLOperationFailed } from '../../adapter/GraphQLClient';
import { SingleDirectorUserFragment } from './../../generated/graphql';

const singleDirectorUserFragment = gql`
  fragment SingleDirectorUser on UserDirector {
    id
    name
    email
    profileImageUrl
  }
`;

class UserWebApi {
  private graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public getMe = async (): Promise<SingleDirectorUserFragment> => {
    let result: any;

    try {
      result = await this.graphqlClient.query(
        gql`
          ${singleDirectorUserFragment}
          query directorUser {
            me {
              ...SingleDirectorUser
            }
          }
        `,
      );
    } catch (err) {
      if (err instanceof GraphQLOperationFailed && err.type === 'KaizenAd::Exceptions::RecordNotFound') {
        throw new MeNotFound();
      }

      throw err;
    }

    return result.me as SingleDirectorUserFragment;
  };
}

export class MeNotFound extends Error {
  public readonly name = 'MeNotFound';
  public readonly message = 'The "me" director user is not found.';

  constructor() {
    super();
  }
}

export default UserWebApi;
